import { useEffect } from 'react';

import { getDefaultStore, useAtomValue, useSetAtom } from 'jotai';

import {
  allCountryLabelsAtom,
  allCountryLabelsErrorAtom,
  allCountryLabelsLoadingAtom,
} from '../../states/country-labels.state';
import { useGetAllCountryLabelsLazyQuery } from '../graphql/generated/graphql';

export function useGetAllCountryLabels() {
  const setCountryLabels = useSetAtom(allCountryLabelsAtom);
  const setLoading = useSetAtom(allCountryLabelsLoadingAtom);
  const setError = useSetAtom(allCountryLabelsErrorAtom);
  const countryLabels = useAtomValue(allCountryLabelsAtom);
  const loading = useAtomValue(allCountryLabelsLoadingAtom);
  const error = useAtomValue(allCountryLabelsErrorAtom);

  const [executeFetch] = useGetAllCountryLabelsLazyQuery({
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const store = getDefaultStore();
    if (store.get(allCountryLabelsAtom).length > 0) return; // already loaded
    if (store.get(allCountryLabelsLoadingAtom)) return; // fetch already in progress
    setLoading(true);
    setError(undefined);
    void executeFetch()
      .then((result) => {
        if (result.data?.allCountryLabels) {
          setCountryLabels(result.data.allCountryLabels);
        }
      })
      .catch((err: Error) => setError(err))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { countryLabels, loading, error };
}
